import { forwardRef } from 'react';
import { Backdrop, Box, Fade, Modal } from '@mui/material';
import customTwMerge from 'utils/twMerge';
import { ICModal } from 'types/atoms';

const CModal = forwardRef<HTMLDivElement, ICModal>(
  ({ open, onClose, className, children, ...rest }, ref) => {
    return (
      <Modal
        {...rest}
        ref={ref}
        open={open}
        onClose={onClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box
            className={customTwMerge(
              'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white p-2 shadow-sm',
              className
            )}
          >
            {children}
          </Box>
        </Fade>
      </Modal>
    );
  }
);

export default CModal;
